module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGmb2P///yH5BAAHAP8ALAAAAAAMAAwAAAIUhI+pGx38TERtnWoBthte2GViUgAAOw=="